import { Container, rem, Text, useMantineTheme } from '@mantine/core';

export const ErrorPage403 = () => {
  const theme = useMantineTheme();

  return (
    <Container style={{ paddingTop: rem(80), paddingBottom: rem(80) }}>
      <Text
        c={theme.colors.dark[6]}
        size="lg"
        style={{
          textAlign: 'center',
          maxWidth: rem(500),
          margin: 'auto',
        }}
      >
        There is a problem with the online form.
      </Text>
      <Text
        c={theme.colors.dark[6]}
        size="lg"
        style={{
          textAlign: 'center',
          maxWidth: rem(500),
          margin: 'auto',
        }}
      >
        Error code: <b>81a</b>
      </Text>
    </Container>
  );
};
